{
  "version": 1,
  "asset_id": "cf17c1fe-c368-4ea1-a52c-f96ffc4962c1",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/cf17c1fe-c368-4ea1-a52c-f96ffc4962c1/hiatal-type-3-es-v3-800.jpg",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/cf17c1fe-c368-4ea1-a52c-f96ffc4962c1/hiatal-type-3-es-v3-800.jpg",
  "original_filename": "hiatal-type-3-es-v3-800.jpg",
  "size": 130839,
  "content_type": "image/jpeg",
  "created_at": "2026-10-28T22:48:09Z"
}
